import { styled } from "@mui/styles";
import { Theme } from "@mui/material/styles";

export const StyledCopyButton = styled("button")(({ theme }: { theme: Theme }) => ({
    position: "absolute",
    top: 8,
    right: 8,
    background: theme?.palette?.mode === "dark" ? "#444" : "#f0f0f0",
    color: theme?.palette?.mode === "dark" ? "#fff" : "#000",
    border: `1px solid ${theme?.palette?.divider}`,
    borderRadius: 4,
    padding: "4px 8px",
    cursor: "pointer",
    fontSize: "0.8rem",
    zIndex: 10,
    transition: "background 0.2s ease",
}));

export const StyledCodeBlockContainer = styled("div")({
    position: 'relative',
})